import React from 'react';

import {Markdown} from '../../markdown';

import css from '../../markdown.module.css';

type Props = {
	/** якорь таблицы: на её подпись ссылаются из текста книги */
	id?: string;
	caption?: string;
	/** сноска под таблицей в разметке сайта: `footer="\* Вместо убежища — {@spell command, приказ}."` */
	footer?: string;
};

/** Таблица с подписью: `[table id="…" caption="…" footer="…"]`, сама таблица — markdown внутри */
export const TableFigure: React.FC<React.PropsWithChildren<Props>> = ({id, caption, footer, children}) => (
	<figure className={css.tableFigure} id={id}>
		{caption && <figcaption className={css.tableCaption}>{caption}</figcaption>}
		{children}
		{footer && (
			<div className={css.tableFooter}>
				<Markdown text={footer} />
			</div>
		)}
	</figure>
);
